import styles from './style.module.scss';
import topIcon from '../../assets/svg/time-line-top.svg';
import bottomIcon from '../../assets/svg/time-line-bottom.svg';
import activeIcon from '../../assets/svg/time-line-active.svg';
import defaultIcon from '../../assets/svg/time-line-default.svg';
import classNames from 'classnames';

interface IProps {
  readonly selectTimeKey: string;
  readonly setSelectTimeKey: (value: string) => void;
  readonly classifyList: string[];
}

export const RoadmapTimeLine = (props: IProps) => {
  return (
    <div className={styles.roadmapTimeLineBox}>
      <img src={topIcon} className={styles.topIcon} />
      <div className={styles.timeLine}>
        {props.classifyList.map((item, index) => {
          if (index > 2) {
            return null;
          }
          return (
            <div
              className={
                props.selectTimeKey === item ? styles.activeTimeLine : ''
              }
            >
              <div
                className={classNames(
                  styles.timeLineDefault,
                  styles[`timeLine${index}`]
                )}
                onClick={() => props.setSelectTimeKey(item)}
              >
                <img
                  src={props.selectTimeKey === item ? activeIcon : defaultIcon}
                />
                <span>{item}</span>
              </div>
            </div>
          );
        })}
      </div>
      <img src={bottomIcon} className={styles.bottomIcon} />
    </div>
  );
};
